import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import MobileInput from "../MobileInput/MobileInput";
import { useParams, useSearchParams } from "react-router-dom";
type Params = { passcode?: string };
function JoinUs() {
  const { passcode } = useParams<Params>();

  const [showPassword, setShowPassword] = useState(false);
  const [isOkToGo, setIsOkToGo] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [joinUsObject, setJoinUsObject] = useState<any>({
    Password: "",
    ConfirmPassword: "",
    Initials: "",
    MobileNumber: "+44",
  });
  const [joinUsValidationObject, setJoinUsValidationObject] = useState<any>({
    LoadingState: false,
    EmailAvailability: "",
    ErrorMessage: "",
  });

  const [UserMessage, setUserMessage] = useState(
    "All set. Please click below button to get started"
  );
  const [AccountSetUpRequired, setAccountSetUpRequired] = useState(0);

  const [ShowMessage, setShowMessage] = useState(0);
  const [Message, setMessage] = useState("");

  useEffect(() => {
    if (passcode) {
     CheckCodeJoinInvite();
    }
  }, [passcode]);


  function CheckCodeJoinInvite() {
    let object = {} as any;
    object.SelectedCode = passcode;
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/CheckCodeJoinInvite", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_res = response.data.Data[0][0];
          if (l_res.Status == 1) {
            setAccountSetUpRequired(l_res.AccountSetUpRequired);
            if (l_res.AccountSetUpRequired == 1) {
              setUserMessage(
                "All set. Please click below button to get started"
              );
            } else {
              setUserMessage("Invitation Accepted");
            }
          } else {
            setShowMessage(1);
            setMessage(l_res.Message);
          }
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  useEffect(() => {
    checkValidation(false);
  }, [joinUsObject]);

  function checkValidation(takeAction: boolean) {
    if (
      !checkPasswordVaildation() ||
      joinUsObject.Password === "" ||
      joinUsObject.ConfirmPassword === "" ||
      joinUsObject.Initials === "" ||
      joinUsObject.MobileNumber === "" ||
      joinUsValidationObject.EmailAvailability !== "" ||
      joinUsValidationObject.ErrorMessage !== "" ||
      !isMobileNumberOk() ||
      !checkConfirmPasswordVaildation()
    ) {
      if (takeAction) {
        setShowErrorMessage(true);
      }
      setIsOkToGo(false);
    } else {
      setIsOkToGo(true);
      setShowErrorMessage(false);
      if (takeAction) {
        if (joinUsValidationObject.ErrorMessage === "") {
          SavePasswordAndSetUpAccount();
        }
      }
    }
  }

  function checkPasswordVaildation() {
    let IsOk = false;
    if (joinUsObject.Password !== "") {
      var DataPassword = AppContext.PTCheckPasswordValidation(
        joinUsObject.Password
      );
      if (!DataPassword.Valid) {
        joinUsValidationObject.ErrorMessage = DataPassword.Message;
        setJoinUsValidationObject((prevState: any) => ({
          ...prevState,
          ErrorMessage: DataPassword.Message,
        }));
        IsOk = false;
      } else {
        joinUsValidationObject.ErrorMessage = "";
        setJoinUsValidationObject((prevState: any) => ({
          ...prevState,
          ErrorMessage: "",
        }));
        IsOk = true;
      }

      return IsOk;
    }
  }

  function checkConfirmPasswordVaildation() {
    let IsOk = false;
    if (checkPasswordVaildation()) {
      if (joinUsObject.Password !== joinUsObject.ConfirmPassword) {
        joinUsValidationObject.ErrorMessage =
          "Password and Confirm Password are not matched.";
        setJoinUsValidationObject((prevState: any) => ({
          ...prevState,
          ErrorMessage: "Password and Confirm Password are not matched.",
        }));
        IsOk = false;
        setIsOkToGo(false);
      } else {
        joinUsValidationObject.ErrorMessage = "";
        setJoinUsValidationObject((prevState: any) => ({
          ...prevState,
          ErrorMessage: "",
        }));
        IsOk = true;
        setIsOkToGo(true);
      }
    }

    return IsOk;
  }

  function SavePasswordAndSetUpAccount() {
    let object = {} as any;
    object.SelectedCode = passcode;
    object.Password = joinUsObject.Password;
    object.Initials = joinUsObject.Initials;
    object.Mobile = joinUsObject.MobileNumber;
    setJoinUsValidationObject((prevState: any) => ({
      ...prevState,
      LoadingState: true,
    }));
    axiosAuth
      .post(
        AppContext.APIURL + "api/SiteUser/SavePasswordAndSetUpAccount",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");
  useEffect(() => {
    setJoinUsObject((prevState: any) => ({
      ...prevState,
      MobileNumber: SelectedMobileNumber,
    }));
  }, [SelectedMobileNumber]);

  function isMobileNumberOk(): boolean {
    let IsOk = false;
    let mobileNumber = joinUsObject.MobileNumber.split("-");
    if (
      mobileNumber &&
      mobileNumber[0] &&
      mobileNumber[1] &&
      mobileNumber[1] !== ""
    ) {
      IsOk = true;
    } else {
      IsOk = false;
    }
    return IsOk;
  }

  return (
    <>
      {joinUsValidationObject.LoadingState && <LoadingAnimation />}
      <div className="login-fields signup-fields inline-block-d text-center width-100">
         {ShowMessage==1  &&<div className="input-center">
          <h5>{Message}</h5> 
          </div>}
           {ShowMessage==0  && AccountSetUpRequired==0 &&<div className="input-center">
          <h5>{UserMessage}</h5> 
           <a href="/login">Get Started</a> 
          </div>}
        {ShowMessage==0  && AccountSetUpRequired==1 &&<div className="input-center">
          <>
            <input
              type="text"
              placeholder="Initials"
              value={joinUsObject.Initials}
              onChange={(e) =>
                setJoinUsObject((prevState: any) => ({
                  ...prevState,
                  Initials: e.target.value,
                }))
              }
              className="input-field flex-d width-100"
            />
            <div className="flex-d width-100 input-gap"></div>
            <div
              className={`form-field flex-da ${
                joinUsObject.MobileNumberError ? "" : ""
              }`}
            >
              <MobileInput
                SelectedMobileNumber={SelectedMobileNumber}
                SetSelectedMobileNumber={SetSelectedMobileNumber}
              />
            </div>
            <div className="flex-d width-100 input-gap"></div>
            <div className="p-relative width-100">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={joinUsObject.Password}
                onChange={(e) =>
                  setJoinUsObject((prevState: any) => ({
                    ...prevState,
                    Password: e.target.value,
                  }))
                }
                className="input-field flex-d width-100"
              />
              <a
                onClick={() => setShowPassword(!showPassword)}
                className="show-hide-pass"
              >
                {!showPassword && (
                  <img
                    src="https://dft8zj8i6wy63.cloudfront.net/mnv/images/eye.svg"
                    width="18"
                    height="14"
                    alt="Eye"
                  />
                )}
                {showPassword && (
                  <img
                    src="https://dft8zj8i6wy63.cloudfront.net/mnv/images/eye-slash.png"
                    width="18"
                    height="14"
                    alt="Eye-Slash"
                  />
                )}
              </a>
            </div>
            <div className="flex-d width-100 input-gap"></div>
            <input
              type="password"
              placeholder="Confirm password"
              value={joinUsObject.ConfirmPassword}
              onChange={(e) =>
                setJoinUsObject((prevState: any) => ({
                  ...prevState,
                  ConfirmPassword: e.target.value,
                }))
              }
              onKeyUp={() => checkConfirmPasswordVaildation()}
              className="input-field flex-d width-100"
            />
            <div
              className="pass-errors"
              dangerouslySetInnerHTML={{
                __html: joinUsValidationObject.ErrorMessage,
              }}
            ></div>
          </>
          <div className="login-btn flex-dj width-100">
            <a
              className={`btn-primary flex-daj  ${
                !isOkToGo ? "btn-disabled" : ""
              }`}
              onClick={() => checkValidation(true)}
            >
              Save
            </a>
          </div>

          {showErrorMessage &&
            joinUsValidationObject.EmailAvailability === "" &&
            joinUsValidationObject.ErrorMessage === "" && (
              <span className="error-message flex-dj">
                You need to fill all the information to get started.
              </span>
            )}
        </div>}
      </div>
    </>
  );
}

export default JoinUs;
